// extracted by mini-css-extract-plugin
export default {"Label":"PostStatusFilterGroup_Label__ZTD5D"};